import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Truncate a UUID or ID string to a short display slug (default 8 chars). */
export function truncateId(id: string, length = 8): string {
  return id.slice(0, length);
}
